import { connect } from 'react-redux'
import {
  selectIsHotkeysModalVisible,
  doHideHotkeysModal,
} from 'ducks/modals/hotkeys'
import View from './view'

const select = state => ({
  visible: selectIsHotkeysModalVisible(state),
})

const perform = {
  close: doHideHotkeysModal,
}

export default connect(select, perform)(View)
